/**
 * Utility to decode JWT and extract manufacturerCustShipToXrefId.
 */
function decodeJwt(): any {
    const jwt = sessionStorage.getItem('apigee-jwt');
    if (!jwt) return null;

    const parts = jwt.split('.');
    if (parts.length < 2) return null;

    let payload: any;
    try {
        payload = JSON.parse(atob(parts[1]));
    } catch (e) {
        console.error('Failed to decode JWT payload:', e);
        return null;
    }

    const userClaimsStr = payload?.user_claims;
    if (!userClaimsStr) return null;

    let userClaims: any;
    try {
        userClaims = JSON.parse(userClaimsStr);
    } catch (e) {
        console.error('Failed to parse user_claims:', e);
        return null;
    }
    return userClaims;
}

export function setManufacturerCustShipToId(): void {
    let userClaims= decodeJwt();
    if(!userClaims) return;
    const xrefId = userClaims.manufacturerCustShipToId;
    if (xrefId) {
        sessionStorage.setItem('manufacturerCustShipToXrefId', String(xrefId));
    }
}

export function setSelectedCustShipTo(): void {
    let userClaims= decodeJwt();
    if(!userClaims) return;
    const custShipTo = userClaims.custShipToId;
    if (custShipTo) {
        sessionStorage.setItem('selectedAccountId', String(custShipTo));
    }
}

/**
 * Checks if a JWT token is expired based on its 'exp' field.
 * @param token JWT string or null
 * @returns true if expired or invalid, false if valid
 */
export function isTokenExpired(token: string | null): boolean {
    if (!token) return true;
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (!payload.exp) return true;
        // exp is in seconds, Date.now() is ms
        return payload.exp < Math.floor(Date.now() / 1000);
    } catch (e) {
        console.log('Error decoding token for expiration check:', e);
        return true;
    }
}